import { useRoot } from "../../contexts/Root";
import { useSeekBar } from "../../contexts/SeekBar";
import useBuffers from "../../hooks/useBuffers";
import { Bar } from "./Bar";

export const BufferBar = () => {
  const { width } = useSeekBar();
  const {
    theme: { seekBarBuffer },
  } = useRoot();
  const buffers = useBuffers(width);

  return buffers.map(({ start, end }) => (
    <Bar
      key={`${start}:${end}`}
      show
      offset={start}
      width={end - start}
      zIndex={1}
      color={seekBarBuffer}
    />
  ));
};
